<form name="detailsForm" #detailsForm="ngForm" class="form-v2">
    <div class="modal-header">
        <h4 class="modal-title">Invoice/Receipt</h4>
    </div>
    <div class="modal-body">
        <div
            class="alert alert-block"
            [ngClass]="{ 'alert-info': invoice.AccSyncData != syncBlocked, 'alert-warning': invoice.AccSyncData == syncBlocked }"
            *ngIf="invoice.AccSyncData">
            <p class="text-normal">
                <i class="ti-cloud-up"></i
                >{{
                    invoice.AccSyncData != syncBlocked
                        ? ' This invoice/receipt has been synced to your accounting software.'
                        : ' This invoice/receipt has been blocked from syncing to your accounting software.'
                }}
                <button *ngIf="accountSyncValid" class="btn-bx-secondary-stroked" type="button" (click)="clearSyncData()">
                    {{ invoice.AccSyncData == syncBlocked ? 'Unblock' : 'Resync' }}
                </button>
            </p>
        </div>
        <div class="row">
            <div class="col-xs-12">
                @let contact = purchaseOrder.Contact ?? purchaseOrder.ContactViaGql;
                <p *ngIf="contact" class="text-large margin-bottom-0">
                    {{ contact.BusinessName || contact.Name }}
                </p>
                <p>PO{{ purchaseOrder.OrderNumberString }} {{ purchaseOrder.Description }}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-8">
                <div class="form-group">
                    <label>Reference #</label>
                    <input
                        legacy-css
                        type="text"
                        class="form-control"
                        id="invoiceReference"
                        name="invoiceReference"
                        placeholder="Reference #"
                        [(ngModel)]="invoice.Reference"
                        (ngModelChange)="onReferenceChanged()"
                        maxlength="50"
                        required
                        appAutoFocus
                        [readonly]="readonly" />
                    <a *ngIf="referenceIsDuplicate" href="#/jobs/orders?q={{ getInvoiceReference() }}" target="_blank"
                        ><span
                            class="label label-warning pull-left"
                            tooltip="This number has been used on other orders. Click to see the list."
                            container="body"
                            >Duplicate #</span
                        ></a
                    >
                </div>
            </div>
            <div class="col-xs-4">
                <div class="form-group date-picker-hide-clear">
                    <label>Invoice/Receipt Date</label>
                    <input
                        legacy-css
                        id="invoiceDate"
                        name="invoiceDate"
                        #invoiceDatePicker="bsDatepicker"
                        type="text"
                        class="form-control"
                        [(ngModel)]="invoice.InvoiceDate"
                        bsDatepicker
                        [bsConfig]="{
                            adaptivePosition: true,
                            showWeekNumbers: false,
                            containerClass: 'theme-default',
                            customTodayClass: 'bsdatepicker-today',
                            dateInputFormat: dateFormat,
                        }" />
                </div>
            </div>
        </div>
        <div class="form-group">
            <label>Notes</label>
            <textarea legacy-css class="form-control" id="notes" name="notes" [(ngModel)]="invoice.Note" maxlength="300"></textarea>
        </div>

        <div class="panel panel-white">
            <div class="panel-heading border-light">
                <h4 class="panel-title">Invoice Items</h4>
                <ul class="panel-heading-tabs border-light">
                    <li *ngIf="!readonly">
                        <div class="btn-group">
                            <button
                                type="button"
                                class="btn-bx-primary"
                                id="addItem"
                                name="addItem"
                                (click)="addItem()"
                                *ngIf="isAllowedToReceipt"
                                tooltip="Add item"
                                container="body">
                                <i class="ti-plus"></i>
                            </button>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="panel-body">
                <table class="table table-responsive table-white">
                    <thead>
                        <th>Item Description</th>
                        <th class="text-left" *ngIf="purchaseOrder.Job.CalculationMethod >= 1">Type</th>
                        <th class="text-right">Original Qty</th>
                        <th class="text-right">This Invoice Qty</th>
                        <th class="text-right">Unit Cost</th>
                        <th class="text-right">Total Cost</th>
                        <th class="text-center" *ngIf="purchaseOrder.Job.CalculationMethod >= 1">{{ taxCode }}</th>
                        <th *ngIf="hasNewItems">Actuals Category</th>
                        <th *ngIf="hasNewItems"></th>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of items">
                            <td class="condensed-col">
                                <span
                                    *ngIf="
                                        !item.isNew && (item.orderItem.AccSyncData != 'Imported' || !isBillBeingImportedIntoPurchaseOrder)
                                    "
                                    >{{ item.orderItem.Description }}</span
                                >
                                <input
                                    legacy-css
                                    type="text"
                                    class="form-control"
                                    *ngIf="
                                        item.isNew ||
                                        ((purchaseOrder.AccSyncData === 'Imported' || item.orderItem.AccSyncData === 'Imported') &&
                                            isBillBeingImportedIntoPurchaseOrder)
                                    "
                                    [(ngModel)]="item.orderItem.Description"
                                    [ngModelOptions]="{ standalone: true }"
                                    appSelectAllOnFocus
                                    required
                                    appSelectAllOnFocusFilter="New Item"
                                    maxlength="255" />
                            </td>
                            <td
                                class="condensed-col text-left"
                                style="min-width: 112px; width: 112px"
                                *ngIf="purchaseOrder.Job.CalculationMethod >= 1">
                                <span *ngIf="!item.isNew">{{ taxService.costItemTypeToDisplay(item.invoiceItem.CostItemType) }}</span>
                                <select
                                    legacy-css
                                    *ngIf="item.isNew"
                                    class="form-control"
                                    [(ngModel)]="item.invoiceItem.CostItemType"
                                    [ngModelOptions]="{ standalone: true }"
                                    (ngModelChange)="costItemTypeChanged(item)">
                                    <option *ngFor="let c of taxService.allCostItemTypePairs()" [ngValue]="c.cit">{{ c.display }}</option>
                                </select>
                            </td>
                            <td class="condensed-col text-right">
                                <span>{{ item.orderItem.Quantity | imperial: item.orderItem.IsImperial }}</span>
                            </td>
                            <td class="condensed-col text-right">
                                <span *ngIf="readonly">{{ item.invoiceItem.Quantity | imperial: item.orderItem.IsImperial }}</span>
                                <div class="input-group input-group-sm full-width" *ngIf="!readonly">
                                    <input
                                        legacy-css
                                        appNumeric
                                        [decimals]="3"
                                        class="form-control text-right"
                                        [imperial]="item.orderItem.IsImperial"
                                        [(ngModel)]="item.invoiceItem.Quantity"
                                        [ngModelOptions]="{ standalone: true }"
                                        appNullReplace="0"
                                        [min]="-9999999"
                                        appSelectAllOnFocus />
                                </div>
                            </td>
                            <td class="condensed-col text-right">
                                <span *ngIf="readonly">{{ item.invoiceItem.UnitCost | bxCurrency }}</span>
                                <input
                                    legacy-css
                                    type="text"
                                    *ngIf="!readonly"
                                    class="form-control text-right"
                                    [(ngModel)]="item.invoiceItem.UnitCost"
                                    [ngModelOptions]="{ standalone: true }"
                                    appCurrency
                                    appNullReplace="0"
                                    appSelectAllOnFocus />
                            </td>
                            <td class="condensed-col text-right">{{ item.invoiceItem.TotalCost | bxCurrency }}</td>
                            <td class="text-center" *ngIf="purchaseOrder.Job.CalculationMethod >= 1">
                                <tax-rate-selector
                                    [editable]="item.isNew"
                                    [taxType]="1"
                                    [costItemType]="item.invoiceItem.CostItemType"
                                    [selectedTaxCodes]="item.invoiceItem.TaxRates"
                                    [taxRatesParent]="purchaseOrder"
                                    (selectedChanged)="taxRatesChanged($event, item)"
                                    [placement]="'left'"
                                    [displayAllApplicableCodes]="purchaseOrder.AccSyncData !== 'Imported'"
                                    *ngIf="!purchaseOrder.IsTaxFree"></tax-rate-selector>
                            </td>
                            <td class="condensed-col text-center min-width-60 width-60" *ngIf="hasNewItems">
                                <div class="typeahead-right-align" *ngIf="item.isNew">
                                    <input
                                        legacy-css
                                        type="text"
                                        maxlength="300"
                                        [(ngModel)]="item.orderItem.ParentTask"
                                        [ngModelOptions]="{ standalone: true }"
                                        [typeahead]="parentTasks"
                                        typeaheadOptionField="Description"
                                        class="form-control"
                                        container="body"
                                        [typeaheadMinLength]="1"
                                        typeaheadOnSelect="setParentTaskId(item, $item)"
                                        [typeaheadWaitMs]="10"
                                        [typeaheadIsFirstItemActive]="false" />
                                </div>
                            </td>
                            <td class="condensed-col text-right min-width-60 width 60" *ngIf="hasNewItems">
                                <button
                                    *ngIf="item.isNew"
                                    (click)="deleteItem(item)"
                                    class="btn btn-xs btn-danger"
                                    tooltip="Delete item"
                                    container="body">
                                    <i class="ti-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="col-xs-6"></div>
                <div class="col-xs-6">
                    <div class="row">
                        <div class="col-xs-6">
                            <span class="text-large">Sub Total:</span>
                        </div>
                        <div class="col-xs-6 text-right">
                            <span class="text-large">{{ invoice.Total | bxCurrency }}</span>
                        </div>
                    </div>
                    <div
                        class="row margin-top-5"
                        *ngIf="purchaseOrder.OrderType !== 'work' && !purchaseOrder.IsPickup && purchaseOrder.AccSyncData !== 'Imported'">
                        <div class="col-xs-6 margin-top-5">
                            <span class="text-large">Delivery/Freight</span>
                        </div>
                        <div class="col-xs-6">
                            <input
                                legacy-css
                                type="text"
                                [min]="0"
                                class="form-control text-right"
                                id="deliveryCost"
                                name="deliveryCost"
                                [(ngModel)]="invoice.DeliveryCost"
                                [ngModelOptions]="{ standalone: true }"
                                appCurrency
                                appSelectAllOnFocus
                                appNullReplace="0"
                                [readonly]="readonly" />
                        </div>
                    </div>
                    <div class="row margin-top-5">
                        <div class="col-xs-6 form-inline">
                            <span class="text-large">{{ taxCode }}</span>
                        </div>
                        <div class="col-xs-6 text-right">
                            <span class="text-large">{{ invoice.Tax | bxCurrency }}</span>
                        </div>
                    </div>
                    <div class="row margin-top-5">
                        <div class="col-xs-6 margin-top-5">
                            <span class="text-large">Rounding Adjustment</span>
                        </div>
                        <div class="col-xs-6">
                            <div class="input-group input-group-sm">
                                <span class="input-group-btn">
                                    <button
                                        type="button"
                                        class="btn btn-xs btn-default"
                                        id="increaseAdjustment"
                                        (click)="incrementAdjustment(-0.01)"
                                        [disabled]="invoice.Adjustment < -0.99 || readonly">
                                        <i class="ti-minus"></i>
                                    </button>
                                </span>
                                <input
                                    legacy-css
                                    class="form-control text-right"
                                    type="text"
                                    id="adjustment"
                                    name="adjustment"
                                    [(ngModel)]="invoice.Adjustment"
                                    [ngModelOptions]="{ standalone: true }"
                                    appCurrency
                                    readonly />
                                <span class="input-group-btn">
                                    <button
                                        type="button"
                                        class="btn btn-xs btn-default"
                                        id="decreaseAdjustment"
                                        (click)="incrementAdjustment(0.01)"
                                        [disabled]="invoice.Adjustment > 0.99 || readonly">
                                        <i class="ti-plus"></i>
                                    </button>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row margin-top-5">
                        <div class="col-xs-6">
                            <span class="text-large">{{ purchaseOrder.IsTaxFree ? 'Invoice Total ' : 'Invoice Total (Incl) ' }}</span>
                        </div>
                        <div class="col-xs-6 text-right">
                            <span class="text-large"
                                ><strong>{{ invoice.TotalIncTax | bxCurrency }}</strong></span
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button
            type="button"
            class="btn-bx-secondary-stroked"
            id="btn-block-accounting-sync"
            *ngIf="accountSyncValid && !invoice.AccSyncData && !isBillBeingImportedIntoPurchaseOrder"
            (click)="blockAccountingSync()">
            Exclude from sync
        </button>
        <button type="button" class="btn-bx-secondary-stroked ml-2" id="btn-purchase-order-cancel" (click)="cancel()">Cancel</button>
        <button
            type="button"
            class="btn-bx-secondary ml-2"
            (click)="ok()"
            [disabled]="!detailsForm.valid || readonly"
            id="btn-purchase-order-save-order-partreceived"
            title="Save (Mark Order as Part-Received)">
            Save (Mark Order as Part-Received)
        </button>
        <button
            type="button"
            class="btn-bx-primary ml-2"
            *ngIf="!readonly"
            (click)="ok(true)"
            [disabled]="!detailsForm.valid || readonly"
            id="btn-purchase-order-save-order-received"
            title="Save (Mark Order as Received)">
            Save (Mark Order as Received)
        </button>
    </div>
</form>
